export const SITE_TYPES = [
  "AAA SIte",
  "Shopping Plaza",
  "Office Plaza",
  "Medical",
  "Residential Units",
  "HOA",
  "Single Unit",
  "Hotel",
  "Park",
  "Other",
  "HQ",
] as const;

export type SiteType = (typeof SITE_TYPES)[number];

const SITE_TYPE_ALIASES: Record<string, SiteType> = {
  "aaa site": "AAA SIte",
  "aaa site ": "AAA SIte",
  "shopping center": "Shopping Plaza",
  "shopping plaza": "Shopping Plaza",
  "office": "Office Plaza",
  "office plaza": "Office Plaza",
  "medical": "Medical",
  "apartment": "Residential Units",
  "residential units": "Residential Units",
  "hoa": "HOA",
  "hoa ": "HOA",
  "single unit": "Single Unit",
  "hotel": "Hotel",
  "park": "Park",
  "other": "Other",
  "hq": "HQ",
};

export function normalizeSiteTypeLabel(siteType?: string | null): string {
  const trimmed = (siteType || "").trim();
  if (!trimmed) return "";
  return SITE_TYPE_ALIASES[trimmed.toLowerCase()] || trimmed;
}

export function isSupportedSiteType(siteType?: string | null): siteType is SiteType {
  return SITE_TYPES.includes(normalizeSiteTypeLabel(siteType) as SiteType);
}

export function getSiteTypeAssetName(siteType: string) {
  const slug = siteType
    .trim()
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return `SiteIcon_${slug}`;
}

export const SITE_TYPE_ASSET_NAMES = SITE_TYPES.map(getSiteTypeAssetName);

export const SITE_TYPE_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "all", label: "All Types" },
  { value: "archived", label: "Archive" },
  ...SITE_TYPES.map((type) => ({ value: type, label: type })),
];
